<template>
  <!-- 发货 -->
  <div class="wrapper">
    <admin-title title="发货"></admin-title>

    <div class="header">
      <div class="tip-hit" v-if="rosterTip || fullPayTip">
        <div class="tip" v-if="rosterTip">
          <i class="el-icon-warning"></i>
          <span class="tip-text">{{ rosterTip }}</span>
        </div>
        <div class="tip" v-if="fullPayTip">
          <i class="el-icon-warning"></i>
          <span class="tip-text">{{ fullPayTip }}</span>
        </div>
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane v-if="deliveryType == 1" label="物流配送" name="1"></el-tab-pane>
        <el-tab-pane v-if="deliveryType == 2" label="门店自提" name="2"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 物流订单 -->
    <DeliveryExpress v-if="activeName == 1" :block-tip-status="blockTipStatus"></DeliveryExpress>
    <!-- 自提订单 -->
    <DeliveryPick v-if="activeName == 2" :block-tip-status="blockTipStatus"></DeliveryPick>
  </div>
</template>

<script>
import DeliveryExpress from "./delivery-express.vue";
import DeliveryPick from "./delivery-pick.vue";
import { refreshRiskMemberAPI } from "@/views/order/order-list/api";

export default {
  name: "Delivery",
  components: { DeliveryExpress, DeliveryPick },
  data() {
    return {
      activeName: "1",
      deliveryType: 1,
      rosterTip: "",
      fullPayTip: "",
      blockTipStatus: false,
    };
  },
  watch: {
    deliveryType: {
      immediate: true,
      handler(newV, oldV) {
        if (this.deliveryType == 2) {
          this.activeName = "2";
        } else {
          this.activeName = "1";
        }
      },
    },
  },

  mounted() {
    this.deliveryType = localStorage.getItem("deliveryType");
    this.refreshOrderRiskMember();
  },

  methods: {
    async refreshOrderRiskMember() {
      const res = await refreshRiskMemberAPI(this.$route.params.id);
      if (res.isBlacklist) {
        this.rosterTip = '该用户与黑名单数据库匹配，请复核后谨慎操作！';
        this.blockTipStatus = true;
      }
      if (!res.isFullPay) {
        this.fullPayTip = '客户有未结清订单，请复核后谨慎操作！';
      }
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          handleDeliveryAPI(this.formData).then(() => {
            this.$message.success("发货成功");
            setTimeout(() => {
              this.closePage();
            }, 1000);
          });
        }
      });
    },
    emitAwindow() {
      if (window.opener) {
        if (window.opener.getBpageList) {
          window.opener.getBpageList();
        } else {
          window.opener.frames[0].getBpageList();
        }
      }
    },
    closePage() {
      this.emitAwindow();
      window.close();
      localStorage.removeItem("deliveryType");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;

  .header {
    position: relative;

    .tip-hit {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      font-weight: 600;

      .tip {
        padding: 0 10px;
        background-color: #f8eaeb;
        font-size: 16px;
        line-height: 28px;
        i {
          color: #e34d59;
          vertical-align: baseline;
        }
        .tip-text {
          color: #e34d59;
          font-size: 14px;
          font-weight: 700;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
